module.exports = __webpack_public_path__ + "static/media/cover_maths_9_10_degree.9f83e74c.jpg";